import { styled } from '@mui/material/styles';

type Props = {
    isDisabled: boolean;
    icon?: React.ReactNode | React.ReactNode[];
    size?: number;
};

export const HeaderIcon = ({ isDisabled, icon, size }: Props) => {
    return (
        <Container isDisabled={isDisabled} size={size}>
            {icon}
        </Container>
    );
};

const Container = styled('div')<{ isDisabled: boolean; size?: number }>(({ isDisabled, size = 32, theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: size,
    height: size,
    borderRadius: '100%',
    background: isDisabled ? theme.palette.neutral[100] : theme.palette.semantic.bg.brandLight2,

    '> svg': {
        color: isDisabled ? theme.palette.neutral[300] : theme.palette.semantic.icon.brand
    }
}));
